import OurUsp from '@/app/staticPages/ourUsp'

export default OurUsp
